/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespDealerDetails_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ContactDealerInlineForm_viewer" | "PdpSharedSellerTabsVariant_viewer" | "PdpRespSellerItemTileCarousel_viewer">;
    readonly " $refType": "PdpRespDealerDetails_viewer";
};
export type PdpRespDealerDetails_viewer$data = PdpRespDealerDetails_viewer;
export type PdpRespDealerDetails_viewer$key = {
    readonly " $data"?: PdpRespDealerDetails_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetails_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSellerItemTileCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '9568bd14935dd28941dcd0eac38eb55f';
export default node;
